var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReferrals = function SvgReferrals(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 7.5C15.5 5.567 13.933 4 12 4C10.067 4 8.5 5.567 8.5 7.5C8.5 9.433 10.067 11 12 11C13.933 11 15.5 9.433 15.5 7.5ZM6.53 6.92C6.08 6.65 5.56 6.5 5 6.5C3.34315 6.5 2 7.84315 2 9.5C2 11.1569 3.34315 12.5 5 12.5C6.16 12.5 7.16 11.84 7.66 10.88C6.8 9.77 6.38 8.35 6.53 6.92ZM19 6.5C20.6569 6.5 22 7.84315 22 9.5C22 11.1569 20.6569 12.5 19 12.5C17.84 12.5 16.84 11.84 16.34 10.88C17.2 9.77 17.62 8.35 17.47 6.92C17.92 6.65 18.44 6.5 19 6.5ZM12 13C8.41 13 6 14.68 6 16.75V19H18V16.75C18 14.68 15.59 13 12 13ZM0 19V17C0 15.61 2.39 14.44 4.95 14.1C4.36 14.78 4 15.72 4 16.75V19H0ZM20 19H24V17C24 15.61 21.61 14.44 19.05 14.1C19.64 14.78 20 15.72 20 16.75V19Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReferrals, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/referrals.b6d0de17.svg";
export { ForwardRef as ReactComponent };